import { Beacon } from "./Beacon.js";
/**
 * An observable that applies a transformation function to each event
 * emitted by a source observable and emits the transformed events.
 */
export class MappedObservable extends Beacon {
    /**
     * If provided, maintains a strong reference to a source observable
     * to prevent it from being garbage collected.
     */
    #source$;
    #transform;
    #emitter;
    #subscription;
    constructor(transform, source$) {
        let emitter;
        super((_emitter) => (emitter = _emitter));
        this.#source$ = source$;
        this.#transform = transform;
        this.#emitter = emitter;
        this.#subscription = this.#source$?.subscribe(this);
    }
    next(event) {
        try {
            this.#emitter.next(this.#transform(event));
        }
        catch (error) {
            this.error(error);
        }
    }
    error(error) {
        this.#emitter.error(error);
        this.#subscription?.unsubscribe();
        this.#subscription = undefined;
    }
    complete() {
        this.#emitter.complete();
        this.#subscription?.unsubscribe();
        this.#subscription = undefined;
    }
}
export function mapObservable(arg1, arg2) {
    if (typeof arg1 === "function") {
        const transform = arg1;
        return (source$) => {
            return new MappedObservable(transform, source$);
        };
    }
    const source$ = arg1;
    const transform = arg2;
    // TODO: Remove in production builds
    if (transform === undefined) {
        throw new Error("transform must be provided when the source observable is provided.");
    }
    return new MappedObservable(transform, source$);
}
